import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrgStore } from '@/stores/org-store';
import { deleteA2AIpAllowlist } from '@/services/a2a-ip-allowlist/delete-a2a-ip-allowlist';
import { A2A_IP_ALLOWLIST_QUERY_KEY } from '@/hooks/queries/use-get-a2a-ip-allowlist';

export const useDeleteA2AIpAllowlist = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => deleteA2AIpAllowlist(),
    // Capture the org the delete was issued against, so a mid-flight org
    // switch can't clear a different org's cache entry.
    onMutate: () => ({
      orgId: useOrgStore.getState().currentOrg?.orgid,
    }),
    // Write null rather than invalidating: the config is gone, so a refetch
    // would only 404 back to null anyway. Setting it directly also makes the
    // "Remove Allowlist" control disappear immediately instead of lingering on
    // stale cached data until the background refetch lands.
    //
    // FULL key, not the prefix: setQueriesData would null out every org's
    // cached allowlist, so another org would render as unconfigured.
    onSuccess: (_data, _vars, context) => {
      if (!context?.orgId) return;
      queryClient.setQueryData(
        [A2A_IP_ALLOWLIST_QUERY_KEY, context.orgId],
        null,
      );
    },
  });
};
